import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Tooltip,
  Popconfirm,
  notification,
  Drawer,
  Button,
  Timeline,
} from "antd";
import {
  OrderedListOutlined,
  RollbackOutlined,
  InfoCircleOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import StockTransactionProjectTypeReportFilter from "../Filters/StockTransactionProjectTypeReportFilter";

const ProjectCostReportByProjectList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "PROJE MALİYET RAPORU",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [totalProjectStepCount, setTotalProjectStepCount] = useState(0);
  const [firmName, setFirmName] = useState("");
  const [updateFormData, setUpdateFormData] = useState({});
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [projectStepId, setProjectStepId] = useState(null);
  const [addProjectStepNoteVisibility, setAddProjectStepNoteVisibility] =
    useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [isEditAllowed, setIsEditAllowed] = useState(true);

  useEffect(
    () => getTableData(),
    [props.match.params.firmId, tableDataQueryOptions]
  );

  useEffect(() => {
    RequestHandler.get(`/Firm/GetById/${props.match.params.firmId}`).then(
      (response) => {
        setFirmName(response.name);
      }
    );
  }, []);

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    let take2 = 100;
    const order = "&$orderby=isTotal asc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/ProjectCost/${props.match.params.firmId}?$count=true${query}${order}&$skip=${skip}&$top=${take2}`
    ).then((response) => {
      setTableData({
        data: response?.value,
        loading: false,
        total: response["@odata.count"],
      });

      if (conditions.length == 0) {
        setTotalProjectStepCount(response["@odata.count"]);
      }
    });
  };

  const columns = [
    {
      title: "Ürün Adı",
      dataIndex: "stockName",
      key: "stockName",
      align: "left",
      render: (text, record) => {
        // isTotal ise kalın yaz, değilse normal
        const style = record.isTotal
          ? { fontWeight: "bold", fontSize: "15px" }
          : { whiteSpace: "break-spaces" };

        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={style}>
              {text.length < 20 ? text : text.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      key: "stockCode",
      align: "left",
      render: (text, record) => {
        if (record.isTotal) return <b>{text}</b>; // Toplam satırında "---" gelecek zaten
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text.length < 20 ? text : text.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Güncel Stok",
      dataIndex: "currentCount",
      key: "currentCount",
      render: (text, record) => (record.isTotal ? "-" : renderDecimal(text)),
    },
    {
      title: "Depo Adı",
      dataIndex: "transactionProjectTypeName",
      key: "transactionProjectTypeName",
      align: "left",
      render: (text, record) => {
        if (record.isTotal) return <span>{text}</span>;
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text.length < 20 ? text : text.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Depo Kodu",
      dataIndex: "projectCode",
      key: "projectCode",
      align: "left",
      render: (text, record) => {
        if (record.isTotal) return <span>{text}</span>;
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text.length < 20 ? text : text.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Toplam Maliyet",
      dataIndex: "totalCostString",
      key: "totalCostString",
      align: "left",
      render: (text, record) => (
        <span
          style={{
            fontWeight: record.isTotal ? "bold" : "normal",
            color: record.isTotal ? "#1890ff" : "inherit",
          }}
        >
          {text}
        </span>
      ),
    },
  ];
  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  return (
    <>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={22}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>

        <Col xs={24} md={6} lg={2} style={{ textAlign: "start", fontSize: 16 }}>
          <p style={{ fontWeight: "bold", color: "#2c3e50" }}>
            <span style={{ color: "#6f5196" }}>{firmName}</span>
          </p>
        </Col>
      </Row>
      <StockTransactionProjectTypeReportFilter
        firmId={props.match.params.firmId}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isUseStockId={false}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            expandable={{
              expandedRowRender: (record) => (
                <Table
                  columns={[
                    {
                      title: "Hareket Tipi",
                      dataIndex: "movementTypeName",
                      key: "type",
                    },
                    {
                      title: "Adet",
                      dataIndex: "count",
                      key: "count",
                      render: (text, record) =>
                        record.isTotal ? "-" : renderDecimal(text),
                    },
                    {
                      title: "Birim Fiyat",
                      dataIndex: "unitPrice",
                      key: "price",
                      render: (text, record) =>
                        record.isTotal ? "-" : renderDecimal(text),
                    },
                    { title: "Toplam", dataIndex: "lineTotal", key: "total" },
                  ]}
                  dataSource={record.details}
                  pagination={false}
                />
              ),
              rowExpandable: (record) =>
                record.details.length > 0 && !record.isTotal,
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="stockId"
            rowClassName={(record) =>
              record.isTotal ? "total-row-highlight" : ""
            }
          ></Table>
        </Col>
      </Row>
    </>
  );
};

export default ProjectCostReportByProjectList;
